import { Grid, TextField, Button } from "@mui/material";

export default function TrainSearch() {
  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} md={3}>
          <TextField label="From Station" fullWidth />
        </Grid>
        <Grid item xs={12} md={3}>
          <TextField label="To Station" fullWidth />
        </Grid>
        <Grid item xs={12} md={3}>
          <TextField label="Class" fullWidth />
        </Grid>
        <Grid item xs={12} md={3}>
          <TextField
            type="date"
            label="Travel Date"
            InputLabelProps={{ shrink: true }}
            fullWidth
          />
        </Grid>
      </Grid>

      <Button fullWidth sx={{ mt: 3 }} variant="contained">
        Search Trains
      </Button>
    </>
  );
}
